import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StockBadgeComponent} from './stock-badge.component';
import {RouterModule} from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    StockBadgeComponent,
  ],
  exports: [
    StockBadgeComponent,
  ]
})
export class StockBadgeModule {

}
